import React, { useEffect } from 'react';
import classNames from 'classnames';
import { IconButton } from 'lib/@mui';

import * as meshBot from '../../constants/MeshbotConstant';

import { calculateNewValue } from './utils';

import { IcControlsDropDownUpDownUp } from '../../assets/icons';
import styles from './InputNumberArrows.module.scss';

const { component, arrows, drop_down, disabled_button, component_with_helper_text } = styles;

const InputNumberArrows = (props) => {
    const { onChange, value, max, min, disabled, name, step = 1, showHelperText, error } = props;
    const stepTimeoutRef = React.useRef();

    // We increase or decrease the value by the step value
    const onStep = (up, inputValue) => {
        const newValue = calculateNewValue(inputValue, up, max, min, step);
        onChange(templateValueForInput(newValue));

        return newValue;
    };

    // We will interval update step when hold mouse down
    const onStepMouseDown = (e, up) => {
        e.preventDefault();

        // Loop step for interval
        function loopStep(value) {
            const newValue = onStep(up, value);
            stepTimeoutRef.current = setTimeout(() => loopStep(newValue), meshBot.INPUT_NUMBER_STEP_INTERVAL);
        }

        const newValue = onStep(up, value);
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(() => loopStep(newValue), meshBot.INPUT_NUMBER_STEP_DELAY);
    };

    const onStopStep = () => {
        clearTimeout(stepTimeoutRef.current);
    };

    useEffect(() => onStopStep, []);

    const templateValueForInput = (newValue) => {
        return {
            target: {
                value: newValue,
                name,
                min,
                max,
            },
        };
    };

    const sharedHandlerProps = {
        onMouseUp: onStopStep,
        onMouseLeave: onStopStep,
    };

    return (
        <div className={classNames(component, { [component_with_helper_text]: showHelperText || error })}>
            <div
                className={classNames(arrows, {
                    [disabled_button]: disabled,
                })}
            >
                <IconButton
                    {...sharedHandlerProps}
                    onMouseDown={(e) => {
                        onStepMouseDown(e, true);
                    }}
                    disabled={disabled}
                >
                    <IcControlsDropDownUpDownUp />
                </IconButton>
                <IconButton
                    {...sharedHandlerProps}
                    onMouseDown={(e) => {
                        onStepMouseDown(e, false);
                    }}
                    className={drop_down}
                    disabled={disabled}
                >
                    <IcControlsDropDownUpDownUp />
                </IconButton>
            </div>
        </div>
    );
};

export default InputNumberArrows;
